export const APP_VERSION = '1.6'
export const APP_VERSION_LABEL = 'V1.6 (October 2026)'
export const COURSE_VERSION = '1.0'
export const AUTHOR = 'Namiranian, Babak'
